import React from "react";
import { Col, Row, Table, Tag } from "antd";
import type { TableProps } from "antd";
import "./index.css";
import IPWhiteListIcon from "./../../../assets/svgs/IPWhiteList.svg";
import IPTVIcon from "./../../../assets/svgs/IPTVIcon.svg";
import CATVIcon from "./../../../assets/svgs/CATVIcon.svg";
import INTERNETIcon from "./../../../assets/svgs/INTERNETIcon.svg";
import { useNavigate } from "react-router-dom";
import NetwalaPagination from "../Pagination/NetwalaPagination";
import TailSpinLoader from "../Loaders/TailSpinLoader";
import { formatDateForJustMonthDayAndYear } from "../../../helpers/date";
import PromisedTransactionIcon from "./../../../assets/svgs/PromisedTransactionIcon.svg";

const ExpiringUsersTable: React.FC<ExpiredUsersTable> = ({
  users,
  pagination,
  handlePageSwitch,
  handlePageSizeChange,
  isLoading,
}) => {
  const navigate = useNavigate();
  const columns: TableProps<ExpiredUsersTableProp>["columns"] = [
    {
      title: "S.No",
      dataIndex: "intPkConnectionID",
      key: "intPkConnectionID",
      render: (text) => <span>{text < 10 ? `0${text}` : text}</span>,
    },
    {
      title: "ISP",
      render: (row) =>
        row.ispLogoUrl && (
          <img style={{ maxHeight: "40px" }} src={row.ispLogoUrl} />
        ),
    },
    {
      title: "Full Name",
      // dataIndex: "intPkHeadID",
      // key: "intPkHeadID",
      render: (row) => (
        <span style={{ display: "flex" }}>
          {row.totalOpenPromises > 0 ? (
            <img
              src={PromisedTransactionIcon}
              style={{ maxWidth: "20px", marginLeft: "-10px" }}
              className="cursor-pointer"
            />
          ) : null}{" "}
          <span>{row.fullName}</span>
        </span>
      ),
    },
    {
      title: "Username",
      dataIndex: "username",
      key: "username",
      width: 150,
      render: (text) => (
        <Tag
          style={{
            fontWeight: "bold",
            wordBreak: "break-word",
            whiteSpace: "normal",
            maxWidth: "150px",
            display: "inline-block",
          }}
        >
          {text ? text : "-"}
        </Tag>
      ),
    },
    {
      title: "Area",
      dataIndex: "areaName",
      key: "areaName",
    },
    {
      title: "Address",
      dataIndex: "address",
      key: "address",
    },
    {
      title: "Expiry Date",
      dataIndex: "expiryDate",
      render: (text) => (
        <span>
          {text ? formatDateForJustMonthDayAndYear(new Date(text)) : "---"}
        </span>
      ),
    },
    {
      title: "Pending Invoices",
      dataIndex: "totalPendingInvoices",
      key: "totalPendingInvoices",
      render: (text) => (
        <Tag
          color={text > 0 ? "warning" : "success"}
          style={{ fontWeight: "bold" }}
        >
          {text > 0 ? text : "---"}{" "}
        </Tag>
      ),
    },
    {
      title: "Type",
      align: "right",

      dataIndex: "",
      render: (row) => {
        return (
          <div className="users-table-action-container">
            {row.connectionType === "CATV" ? (
              <img src={CATVIcon} className="cursor-pointer" />
            ) : null}
            {row.connectionType === "INTERNET" ? (
              <img src={INTERNETIcon} className="cursor-pointer" />
            ) : null}
            {row.staticIpDetails !== null ? (
              <img src={IPWhiteListIcon} className="cursor-pointer" />
            ) : null}
            {row.iptvDetails ? (
              <img src={IPTVIcon} className="cursor-pointer" />
            ) : null}
          </div>
        );
      },
    },
  ];

  return (
    <div className="netwala-users-table-container">
      {isLoading === true ? (
        <TailSpinLoader />
      ) : (
        <Row>
          <Col span={24}>
            <Table
              className="netwala-users-table striped-table"
              columns={columns}
              dataSource={users}
              rowKey={(record) => record.intPkConnectionID}
              scroll={{ x: "max-content" }}
              onRow={(record, rowIndex) => {
                return {
                  onClick: (event) => {
                    navigate(
                      `/user-connection-details/${record.intPkHeadID}/${record.intPkConnectionID}?activeTab=1&fullName=${record.fullName}`
                    );
                  }, // click row
                };
              }}
              pagination={false}
            />
          </Col>
          <Col
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "20px",
              marginBottom: "20px",
            }}
            span={24}
          >
            <NetwalaPagination
              pagination={pagination}
              handlePageSwitch={handlePageSwitch}
              handlePageSizeChange={handlePageSizeChange}
            />
          </Col>
        </Row>
      )}
    </div>
  );
};
export default ExpiringUsersTable;
